module.exports = __webpack_public_path__ + "static/media/coutts.5ea7b9bf.svg";